import React from 'react';
import PropTypes from 'prop-types';

/**
 * renders a pdf from its public url. an iframe hands the file to the browser's own
 * viewer, which loads it as a document instead of a cross-origin fetch — so it works
 * whether or not the bucket sends CORS headers. this is the one place to change if
 * the viewer ever moves to react-pdf.
 * @param url - public object url of the pdf
 * @param title - accessible title for the frame
 */
export default function PdfViewer({ url, title }) {
  return (
    <div className='h-[75vh] w-full'>
      <iframe
        src={url}
        title={title}
        className='h-full w-full rounded-md border-0'
      />
    </div>
  );
}

PdfViewer.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
